import { useMutation } from '@tanstack/react-query';

import { IncidentClient } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const incidentClient = new IncidentClient(apiBaseUrl);

function useDeleteIncident() {
  return useMutation({
    mutationKey: [queryKeys.Incident.Delete],
    mutationFn: (id: number) => incidentClient.delete(id),
  });
}

export default useDeleteIncident;
